import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {LogService} from '../../services/log.service';
import {AppSettings} from '../../helpers/app-settings';
import {AuthService} from '../../auth/auth.service';
import {ErrorHandlingService} from '../common/error-handling.service';
import {UserValidationLocalService} from '../../services/user-validation-local.service';

@Injectable()
export class ValidityTokenInterceptor implements HttpInterceptor {

  constructor(private log: LogService, private appSettings: AppSettings,
              private authService: AuthService,
              private errorHandling: ErrorHandlingService,
              private userValidationLocalService: UserValidationLocalService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const body = req.body;

    // Se reemplaza el parametro
    if (body !== null && body['validity_token'] !== undefined) {
      if (!this.userValidationLocalService.isActive()) {
        body['validity_token'] = undefined;
      } else {
        const tokens = this.userValidationLocalService.getValidTokens();
        if (tokens.length > 0) {
          body['validity_token'] = tokens[0].token;
        }
      }
    }


    return next.handle(req.clone({
      body
    }))
      .pipe(
        map((event: HttpEvent<any>) => {
          return event;
        })
      );

  }

}
